import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Rate, Button, Carousel, App } from 'antd';
import styles from './index.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import { 
  getProductDetail, 
  saveUserBrowserRecord, 
  saveUserCollect, 
  getIsCollectionProduct 
} from '@/api/products';
import {
  getMerchantInfo
} from '@/api/store';
import { saveToCart } from '@/api/cart';
import { HeartOutlined, HeartFilled } from '@ant-design/icons';
import { useAppSelector } from '@/store/hooks';
import { createChatRoom } from '@/api/message';

import { IFormDataAll, ISkuList } from '@/pages/StorePublishProduct/types';

import { eventBus } from '@/utils/eventBus';

import icon1 from '@/assets/images/组 2387@2x.png';
import icon2 from '@/assets/images/路径 1659@2x.png';
import pic1 from '@/assets/images/Merchant _url.png';

import icon4 from '@/assets/images/组件 7 – 2@2x.png';

import icon5 from '@/assets/images/组 2390@2x.png';
import icon6 from '@/assets/images/路径 1665@2x.png';
import icon7 from '@/assets/images/组 2391@2x.png';
import icon8 from '@/assets/images/路径 90@2x.png';
import CartCounter from '@/components/CartCounter';
import ProductBanner from '@/components/ProductBanner/ProductBanner';
import ProductDetailTemplate1 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate1/ProductDetailTemplate1';
import ProductDetailTemplate2 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate2/ProductDetailTemplate2';
import ProductDetailTemplate3 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate3/ProductDetailTemplate3';
import ProductDetailTemplate4 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate4/ProductDetailTemplate4';
import ProductDetailTemplate5 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate5/ProductDetailTemplate5';
import ProductDetailTemplate6 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate6/ProductDetailTemplate6';
import ProductDetailTemplate7 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate7/ProductDetailTemplate7';
import ProductDetailTemplate8 from '@/pages/StorePublishProduct/components/Template/ProductDetailTemplate8/ProductDetailTemplate8';
import { useTranslation } from 'react-i18next';

const ProductDetail: React.FC = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { message } = App.useApp();
  const { t } = useTranslation();

  const token = useAppSelector((state) => state.user.token);
  //店铺评分
  const [value, setValue] = useState(5);

  //购物车计数器
  const [count, setCount] = useState(1);

  //计数器是否禁用
  const [countDisabled, setCountDisabled] = useState(false);

  //是否收藏
  const [isCollect, setIsCollect] = useState(false);

  // 店铺详情
  const [merchantInfo, setMerchantInfo] = useState<any>({});

  //表单的总数据
  const [formDataAll, setFormDataAll] = useState<IFormDataAll>(

    {
      merchant_id: "",
      user_id: '',
      product_id: "",
      status: 1,
      is_delete: false,
      product_category_id: null,
      product_category_brand_id: null,
      product_spu_id: null,
      product_title: "",
      product_content: [],
      product_status: 1,
      // 第二页价格相关
      launch_option: 'schedule',
      // 第三页物流相关
      delivery_estimated_time: '24hours',
      delivery_method: 1,
      product_sku_values: [
        // {
        //   "brand_name": "Apple",
        //   "is_on_shelf": true,
        //   "product_spu_name": "iphone 16 pro max", "product_sku_id": 1, "product_price": 1, "product_stock": 2,
        //   "specs": [{ "lable": "产地", "value": "America", "product_base_attribute_id": 3 }, { "lable": "颜色", "value": "白色", "product_base_attribute_id": 17 }]
        // },

      ],
      product_media_list: [
        // {
        //   "product_id": "201752483170745bdffebf6aa0e",
        //   "product_media_type": "images",
        //   "product_media_file_url": "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        //   "product_media_video_cover_id": null,
        //   "file_id": 7
        // }
      ],

      product_video_list: [
        // {
        //   "product_id": "201752483170745bdffebf6aa0e",
        //   "product_media_type": "images",
        //   "product_media_file_url": "https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png",
        //   "product_media_video_cover_id": null,
        //   "file_id": 7
        // }
      ],

      //自定义属性
      product_custom_attributes: [
        // {
        //   "attribute_name": "自定义属性名称1",
        //   "attribute_value": "自定义属性值1"
        // },

      ],
      product_del_media_list: []
    }
  );

  // sku列表
  const [parentSkuList, setParentSkuList] = useState<ISkuList[]>([
    // {
    //   brand_name: 'Apple',
    //   product_spu_name: 'iphone 16',
    //   product_sku_id: 1,
    //   product_price: 99.0,
    //   product_stock: 20,
    //   specs: [{ lable: '产地', value: 'America', product_base_attribute_id: 3 }],
    //   is_on_shelf: false,
    // },
  ]);

  //轮播图图片和视频
  const [imgList, setImgList] = useState<Array<{url: string, type: 'image' | 'video', thumbnail?: string}>>([
    // 'https://img.alicdn.com/imgextra/i2/2563725160/O1CN01yL26rH1nzKefzLlpN_!!0-item_pic.jpg_.webp',
  ]);





  // 当前选中的sku对象
  const [matchedSKU, setMatchedSKU] = useState<any>({
    brand_name: "",
    create_time: "",
    is_delete: false,
    is_on_shelf: true,
    product: { product_id: '', product_title: '' },
    product_price: "",
    product_sku_id: "c",
    product_spu_name: "",
    product_stock: 0,
    specs: [],
    update_time: ""
  });


  //收藏
  const handleCollect = () => {
    saveUserCollect({ product_id: params.id }).then((res) => {
      if (res.code === 200) {
        message.success(res.data);
        setIsCollect(true);
      } else {
        message.error(res.message);
      }
    });
  }

  //取消收藏
  const handleCancelCollect = () => {
    saveUserCollect({ product_id: params.id, is_delete: true }).then((res) => {
      if (res.code === 200) {
        message.success(res.data);
        setIsCollect(false);
      } else {
        message.error(res.message);
      }
    });
  }

  //根据选项匹配SKU对象
  const matchSKU = (product_sku_values: any[], selectedSpecsCopy: { [key: number]: string }) => {
    // 只匹配is_selected=true的SKU
    const selectedSkus = product_sku_values.filter(sku =>
      sku.specs.every((spec: any) => spec.is_selected !== false)
    );

    return selectedSkus.find((sku) => {
      const specMap = sku.specs.reduce((acc: Record<string, string>, spec: any) => {
        acc[spec.product_base_attribute_id] = spec.value;
        return acc;
      }, {});

      // 判断每一个选中的规格是否匹配当前 SKU 的规格
      return Object.entries(selectedSpecsCopy).every(
        ([attrId, selectedValue]) => specMap[attrId] === selectedValue
      );
    });
  }

  // 产品规格数据
  const [productSpecs, setProductSpecs] = useState<any[]>([
    // {"product_base_attribute_id":3,"label":"产地","values":["America","India"]},
  ]);

  // SKU选中状态管理
  // {"3":"America","17":"白色"}
  const [selectedSpecs, setSelectedSpecs] = useState<{ [key: number]: string }>({});





  // 处理SKU选项点击
  const handleSpecClick = (specId: number, value: string) => {

    setSelectedSpecs(prev => ({
      ...prev,
      [specId]: value
    }));
  };

  // 提取sku属性列表
  const extractSpecs = (skuList: any[]) => {
    const specMap = new Map();

    // 只处理is_selected=true的SKU
    const selectedSkus = skuList.filter(sku =>
      sku.specs.every((spec: any) => spec.is_selected !== false)
    );

    selectedSkus.forEach((sku) => {
      sku.specs.forEach((spec: any) => {
        const { product_base_attribute_id, lable, value } = spec;

        if (!specMap.has(product_base_attribute_id)) {
          specMap.set(product_base_attribute_id, {
            label: lable,
            values: new Set()
          });
        }

        specMap.get(product_base_attribute_id).values.add(value);
      });
    });

    // 转为数组形式
    return Array.from(specMap.entries())?.map(([id, { label, values }]) => ({
      product_base_attribute_id: id,
      label,
      values: Array.from(values)
    }));
  }

  //计数器change事件
  const handleCountChange = (newCount: number) => {
    console.log(newCount);

    setCount(newCount);
  };

  // 移动端
  const onChange = (currentSlide: number) => {
    // console.log(currentSlide);
  };

  //购买按钮
  const handleBuyNow = () => {
    // 库存为0时，提示库存不足
    if (matchedSKU.product_stock <= 0) {
      message.error(t('ProductDetail.insufficientStock'));
      return;
    }
    const productsToOrder = [{
      product_id: matchedSKU.product.product_id,
      quantity: count,
      product_sku_id: matchedSKU.product_sku_id,
    }];
    const encodedData = btoa(JSON.stringify(productsToOrder));
    navigate(`/PlaceOrder?productsToOrder=${encodedData}`);
  }
  // 加入购物车
  const handleAddToCart = () => {
    if(matchedSKU?.product_stock <= 0){
      message.error(t('ProductDetail.insufficientStock'));
      return;
    }

    if(!matchedSKU?.is_on_shelf){
      message.error(t('ProductDetail.productNotOnShelf'));
      return;
    }
    const params = {
      product_id: matchedSKU?.product?.product_id || '',
      product_sku_id: matchedSKU?.product_sku_id || '',
      quantity: count
    };

    saveToCart(params).then((res) => {
      if (res.code === 200) {
        message.success(res.data);
        eventBus.emit('addCart',params.quantity || 0);
      } else {
        message.error(res.message);
      }
    }).catch((error) => {
      // message.error('Failed to add product to cart');
    });
  };


  // 打开聊天室
  const handleCreateChatRoom = () => {
    createChatRoom({ member_id: formDataAll?.user_id || '' }).then((res) => {
      if (res.code == 200) {
        navigate(`/chatList?chatRoomId=${res.data.room_id}`);
      } else {
        message.error(res.message);

      }
    });
  }


  // 初始化默认选中第一个选项
  useEffect(() => {

    const defaultSelected: { [key: number]: string } = {};

    productSpecs.forEach(spec => {
      if (spec.values && spec.values.length > 0) {
        defaultSelected[spec.product_base_attribute_id] = spec.values[0];
      }
    });

    setSelectedSpecs(defaultSelected);


  }, [productSpecs]);


  //监听选择sku属性的变化 获取当前sku组合对象
  useEffect(() => {
    const matchedSkuCopy = matchSKU(parentSkuList, selectedSpecs);

    console.log('matchedSkuCopy2', matchedSkuCopy);

    setMatchedSKU(matchedSkuCopy);

    setCount(matchedSkuCopy?.product_stock > 0 ? 1 : 0);

  }, [selectedSpecs]);

  //mounted
  useEffect(() => {
    if (params.id) {
      console.log(params.id);
      // 获取商品详情
      getProductDetail({ product_id: params.id }).then((res) => {
        console.log(res, 'res');
        if (res.code === 200) {
          res.data.product_category_id =
            res?.data?.product_category?.product_category_id || null;

          res.data.product_category_brand_id =
            res?.data?.product_category_brand?.product_category_brand_id || null;

          res.data.product_spu_id =
            res?.data?.product_spu?.product_spu_id || null;

          setFormDataAll(res.data);

          setParentSkuList(res?.data?.product_sku_values || []);

          //获取配置项列表
          const specs = extractSpecs(res?.data?.product_sku_values || []);


          setProductSpecs(specs);


          // 转换媒体列表,包含类型和封面信息
          setImgList(res?.data?.product_media_list?.map((item: any) => ({
            url: item.product_media_file_url,
            type: item.product_media_type === 'video' ? 'video' : 'image',
            thumbnail: item.product_video_thumbnail || item.product_media_file_url
          })) || []);


          //获取店铺详情
          getMerchantInfo({ merchant_id: res.data.merchant_id }).then((res) => {
            if (res.code == 200) {
              setMerchantInfo(res.data);
            }
          })
          
        }
      });
    }

    if(token){
      //保存浏览记录
      saveUserBrowserRecord({
        product_id: params.id,
      });

      //获取是否收藏
      getIsCollectionProduct({ product_id: params.id }).then((res) => {
        if (res.code === 200) {
          setIsCollect(res.data.is_collection);
        }
      });
    }

    
  }, []);


  return (
    <div className={styles['product-detail']}>

      <Carousel afterChange={onChange} className={styles.Carousel} autoplay>
        {
          imgList?.map((item, index) => (
            <div key={index}>
              {item.type === 'video' ? (
                <video 
                  src={item.url} 
                  controls 
                  poster={item.thumbnail}
                  className={styles.bannerBoxMiddleImg}
                />
              ) : (
                <img src={item.url} alt="" className={styles.bannerBoxMiddleImg} />
              )}
            </div>
          ))
        }
      </Carousel>

      {/* 详情页头部 */}
      <div className={styles['product-detail-top-box']}>

        <div className={styles['product-name-box']}>
          <img src={merchantInfo?.merchant_logo_file_url || pic1} alt="" className={styles['product-name-img']} />
          <div className={styles['product-name-right']}>
            <div className={styles['product-name-text1']}>
              {merchantInfo?.merchant_name}
            </div>
            <div className={styles['product-name-text2-box']}>
              <div className={styles['product-name-star']}>
                <Rate onChange={setValue} value={value} disabled className={styles['custom-rate']} />
                <span className={styles['product-star-value']}>{value.toFixed(1)}</span>
              </div>
              <div className={styles['product-name-text2']}>{t('ProductDetail.product-name-text2')}</div>
            </div>
          </div>
        </div>

        <div className={`${styles['product-name-text2']} ${styles['product-name-text3']}`}>{t('ProductDetail.highQualityService')}</div>


        <div className={styles['product-btn-box']}>
          <div className={styles['product-btn1']} onClick={handleCreateChatRoom}>
            <img src={icon1} alt="" />
            {t("ProductDetail.product-btn1")}
          </div>
          <div className={styles['product-btn2']} onClick={() => navigate(`/storeDetail/${merchantInfo?.merchant_id}`)}>
            <img src={icon2} alt="" />
            {t("ProductDetail.product-btn2")}
          </div>
        </div>

      </div>
      {/* 详情页头部 */}

      {/* 详情页正文 */}
      <div className={styles['product-detail-content']}>

        <div className={styles['product-detail-content-left']}>
          <div className={styles['product-detail-content-ProductBanner']}>
            <ProductBanner imgList={imgList} />
          </div>

          <div className={styles['product-detail-img-detail']}>
            {/* 自定义属性先隐藏 */}
            {formDataAll?.product_custom_attributes && formDataAll.product_custom_attributes.length > 0 && (
              <div className={styles['product_custom_attribute-box']}>
                <div className={styles['product_custom_attribute-title']}>
                  {t('ProductDetail.product_custom_attribute')}
                </div>
                {
                  formDataAll?.product_custom_attributes?.map((item, index) => {
                    return <div key={index} className={styles['product_custom_attribute-item']}>
                      <div className={styles['attribute-label']}>{item.attribute_name}:</div>
                      <div className={styles['attribute-value']}>{item.attribute_value}</div>
                    </div>
                  })
                }
              </div>
            )}

            {
              formDataAll?.product_content?.map((item, index) => {
                if (item.name === 'template1') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate1 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template2') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate2 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template3') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate3 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template4') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate4 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template5') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate5 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template6') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate6 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template7') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate7 data={item} editable={false} />
                    </div>
                  )
                } else if (item.name === 'template8') {
                  return (
                    <div key={index} className={styles['template-container']}>

                      <ProductDetailTemplate8 data={item} editable={false} />
                    </div>
                  )
                }
                return null;
              })
            }
          </div>
        </div>


        <div className={styles['product-detail-content-right']}>
          <div className={styles['product-detail-name']}>
            {matchedSKU?.product?.product_title || ''}
          </div>

          <div className={styles['product-detail-tag-list']}>
            <div className={styles['product-detail-tag-item']}>{t('ProductDetail.newArrival')}</div>
            <div className={styles['product-detail-tag-item']}>{t('ProductDetail.GoodDeal')}</div>
            <div className={styles['product-detail-tag-item']}>{t('ProductDetail.LimitedTimeSale')}</div>
            {/* <div className={styles['product-detail-tag-item']}>Holiday Name</div> */}
          </div>

          <div className={styles['product-detail-price-box']}>
            <div className={styles['product-detail-price']}>${matchedSKU?.product_price || ''}</div>
            {/* 打折模式的原价 暂时隐藏 */}
            {/* <div className={styles['product-detail-price-origin']}>${matchedSKU?.product_price || ''}</div> */}
          </div>

          {/* 免费送货的提示，暂时没有功能先隐藏 */}
          {/* 
          <div className={styles['product-detail-shipping-box']}>
            <div className={styles['product-detail-shipping-item']}>
              <img src={icon3} alt="" />
              <span>Free shipping for this item</span>
            </div>
            <div className={styles['product-detail-shipping-line']}></div>
            <div className={styles['product-detail-shipping-item']}>
              <img src={icon3} alt="" />
              <span>$5.00 Credit for delay</span>
            </div>
          </div> */}


          {/* {JSON.stringify(matchedSKU)} */}
          <div className={styles['product-detail-sku-box']}>
            {
              productSpecs?.map((spec, specIndex) => (
                <div key={specIndex} className={styles['sku-spec-group']}>
                  <div className={styles['sku-spec-label']}>{spec.label}:</div>
                  <div className={styles['sku-spec-options']}>
                    {spec?.values?.map((value: string, valueIndex: number) => (
                      <div
                        key={valueIndex}
                        className={`${styles['sku-spec-option']} ${selectedSpecs[spec.product_base_attribute_id] === value
                          ? styles['sku-spec-option-selected']
                          : ''
                          }`}
                        onClick={() => handleSpecClick(spec.product_base_attribute_id, value)}
                      >
                        {value}
                      </div>
                    ))}
                  </div>
                </div>
              ))
            }
          </div>

          <div className={styles['product-detail-Quantity-box']}>
            <div className={styles['product-detail-Quantity-text1']}>{t("ProductDetail.product-detail-Quantity-text1")}</div>
            <CartCounter
              disabled={countDisabled}
              initialValue={count}
              onChange={handleCountChange}
              max={matchedSKU?.product_stock || 0}
            />

            <div className={styles['product-collect']}>
              {isCollect ?
                <HeartFilled className={styles['product-collect-icon']} onClick={handleCancelCollect} /> :
                <HeartOutlined className={styles['product-collect-icon']} onClick={handleCollect} />}



            </div>
          </div>

          <div className={styles['product-detail-buy-box']}>
            <div className={styles['product-detail-buy-cart']} onClick={handleAddToCart}>
              <img src={icon4} alt="" />
            </div>
            <Button
              disabled={matchedSKU?.product_stock <= 0 || !matchedSKU?.is_on_shelf}
              className={styles['product-detail-buy-btn']}
              onClick={handleBuyNow}
            >{t("ProductDetail.product-detail-buy-btn")}</Button>
          </div>

          <div className={styles['product-detail-free-box']}>
            {/* 提供送货上门 */}
            {
              formDataAll.delivery_method === 2 &&
              <div className={styles['product-detail-free-item']}>
                <img src={icon5} alt="" className={styles['product-detail-free-img1']} />
                <div className={styles['product-detail-free-text1']}>{t("ProductDetail.FreeShipping")}</div>
                <img src={icon8} alt="" className={styles['product-detail-free-img2']} />
              </div>
            }


            <div className={styles['product-detail-free-item']}>
              <img src={icon6} alt="" className={styles['product-detail-free-img1']} />
              <div className={styles['product-detail-free-text1']}>{t("ProductDetail.SafePayments")}</div>
              <img src={icon8} alt="" className={styles['product-detail-free-img2']} />
            </div>

            <div className={styles['product-detail-free-item']}>
              <img src={icon7} alt="" className={styles['product-detail-free-img1']} />
              <div className={styles['product-detail-free-text1']}>{t("ProductDetail.OrderGuarantee")}</div>
              <img src={icon8} alt="" className={styles['product-detail-free-img2']} />
            </div>

          </div>

          
        

        </div>
      </div>
      {/* 详情页正文 */}

    </div>
  );
};

export default ProductDetail; 